import { apiAdmin } from '@auteco/enviroment/apiRecompensas'

export const getRecompensas = async () => {
  try {
    const response = await apiAdmin.get('/v1/recompensas')
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

export const getParticipantes = async () => {
  try {
    const response = await apiAdmin.get('/v1/participantes')
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

export const sendFileService = async (body) => {
  const response = await apiAdmin.post('/v1/participantes/uploadCSV', body)
  try {
    if (response.status === 200) {
      return response
    }
  } catch (error) {
    console.log('Error get List ')
    return false
  }
}

export const getProductoById = async (id) => {
  try {
    const response = await apiAdmin.get(`/v1/participantes/materiales-activos-sap/id?repuesto_id=${id}`)
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

export const addProducto = async (body) => {
  try {
    const response = await apiAdmin.post('/v1/participantes/crear', body)
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

export const updateRecompensa = async (body) => {
  try {
    const response = await apiAdmin.post('/v1/recompensas', body)
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error('Error updating recompensa:', error)
    return false
  }
}

